// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HTH2","label":"styles_label__2zfc4"};